import theresePic from "@/public/images/artists/therese.png";
import { Artist } from "@/types/types";

export const therese = {
  id: "174",
  name: "Therese",
  image: theresePic,
  description: `Bright and commanding, Thérèse's voice boasts a crisp, subtly nasal tone with a versatile register. Perfect for dynamic performances, she excels in dynamic belting while retaining a sharp, expressive edge ideal for impactful delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftherese-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Rock", "Folk", "Mature", "Unprocessed", "Belting", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Very high",
      },
      specific: {
        low: 52,
        high: 80,
      },
      sweetSpot: 70,
    },
  },
} as const satisfies Artist;
